import React, { Component } from 'react';
import { connect } from 'react-redux';

import ActionType from '../..//redux/reducer/globalActionType';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { redirectUri } from '../../util/redirectUtil';

class Home extends Component {
    componentDidMount() {
        const is_login = this.props.login;
        const token = this.props.token;

        if (!is_login && token === null) {
            return this.props.history.push(ROUTER_CONSTANT.LOGIN);
        }

        if (is_login && token !== null) {
            return redirectUri(this.props.userDetail, this.props.history)
        }
    }

    render() {
        return (
            <>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.authentication.login,
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin: (token) => dispatch({ type: ActionType.IS_LOGIN, token })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);